<template>
  <div>
    <SmallTitle text="Format" />
    <Chip
      v-for="format in Object.values(fileFormats)"
      :key="`format-${format}`"
      name="format"
      :title="format"
      :value="format"
      :checked="selectedFileFormat === format"
      v-on:change="setFileFormat"
    />
  </div>
</template>

<script>
import { mapState, mapMutations } from 'vuex'
import { fileFormats } from '../../../constants'
import SmallTitle from '../../elements/SmallTitle'
import Chip from '../../elements/Chip'
import { SET_PERSONAL_STATE_VALUE } from '../../../store/modules/personal/variables'

export default {
  data() {
    return {
      fileFormats
    }
  },
  components: {
    SmallTitle,
    Chip
  },
  computed: {
    ...mapState('personal', ['selectedFileFormat'])
  },
  methods: {
    ...mapMutations('personal', [SET_PERSONAL_STATE_VALUE]),
    setFileFormat(val) {
      localStorage.setItem('selectedFileFormat', val)
      this[SET_PERSONAL_STATE_VALUE](['selectedFileFormat', val])
    }
  }
}
</script>
